import { sectors, multiple_labels } from "../helpers/new-application-form-helper";
import jQuery from "jquery";

export const displayNewApplicationForm = () => {

    //if (selectedSector) {
    displayCategorySelector();
    //}

    const radioButtons = document.getElementsByName('sector');
    radioButtons?.forEach((radioButton) => radioButton.addEventListener('change', displayCategorySelector));
}

const displayCategorySelector = () => {
    //displayElement('category-selector');
    displaySpecificCategorySelector();
}

const displaySpecificCategorySelector = () => {
    //notShowAnyCategory();

    //const selectedSector = document.querySelector('input[name="sector"]:checked').value;

    //if (selectedSector) {
    //displayElement(`${selectedSector}-category-selector`);

    const radioButtons = document.getElementsByName('category[]');
    radioButtons?.forEach((radioButton) => radioButton.addEventListener('change', handleCategorySelection));
    //}
    const selectedCategory = document.querySelector('input[name="category[]"]:checked');

    if (selectedCategory) {
        handleCategorySelectionDraft();
    }
}

const notShowAnyCategory = () => sectors.forEach((sector) => hideElement(`${sector}-category-selector`));

var Array = [];

const handleCategorySelection = (e) => {

    if (document.querySelector('input[name="category[]"]:checked')) {
        const selectedCategory = document.querySelector('input[name="category[]"]:checked').value;

        if (selectedCategory) {

            if (!Array.includes(e.target.value)) {
                Array.push(e.target.value)

                let nationalRadioForm = document.getElementById('national_radio_form')
                let h4 = nationalRadioForm.getElementsByTagName('h4')
                h4 = h4[h4.length - 1]

                let row = document.createElement('div')
                row.setAttribute('class', 'row')
                row.setAttribute('id', 'row_' + e.target.value)

                let column = document.createElement('div')
                column.setAttribute('class', 'column-s')

                let label = document.createElement('label')
                let name = document.querySelector("label[for=" + e.target.value + "]").textContent
                let lang = (window.location.pathname).search('/en/')
                label.innerHTML = lang == -1 ? 'Motivación de la candidatura - ' : 'Motivation candidacy - '
                label.innerHTML = label.innerHTML + name + '<span class="required_field"> *</span>'
                label.setAttribute('for', 'motivation_' + e.target.value)

                let textarea = document.createElement('textarea')
                textarea.setAttribute('id', 'motivation_' + e.target.value)
                textarea.setAttribute('name', 'motivation_' + e.target.value)
                textarea.setAttribute('maxLength', '800')
                textarea.setAttribute('rows', '5')
                textarea.setAttribute('cols', '50')
                textarea.required = true

                let counter = document.createElement('div')
                counter.setAttribute('id', 'counter_motivation_' + e.target.value)

                counter.innerHTML = '0/' + textarea.getAttribute("maxLength");
    
                textarea.addEventListener('input', function (e) {
                    const target = e.target;
                    const currentLength = target.value.length;
                    counter.innerHTML = currentLength + '/' + textarea.getAttribute("maxLength");
                });

                column.appendChild(label)
                column.appendChild(textarea)
                column.appendChild(counter)
                row.appendChild(column)
                nationalRadioForm.insertBefore(row, h4)


                

            } else {
                let pos = Array.indexOf(e.target.value)
                Array.splice(pos, 1)
                document.getElementById('row_' + e.target.value).remove()
            }
            allowConfirm();
        }
    } else {
        hideElement('confirm_button')
    }
}

const handleCategorySelectionDraft = () => {
    if (document.querySelector('input[name="category[]"]:checked')) {
        const selectedCategory = document.querySelector('input[name="category[]"]:checked').value;
        if (selectedCategory) {
            allowConfirm();
        }
    } else {
        hideElement('confirm_button');
    }
}

const allowConfirm = () => {
    displayElement('confirm_button');

    const confirmButton = document.getElementById('confirm_button');
    confirmButton?.addEventListener('click', displayRestOfTheForm);

    if (document.getElementById('post_exists_confirmation')) {
        confirmButton.click();
    }
}

const displayRestOfTheForm = () => {
    handleFormSubmit();
    handleSaveDraft();
    displayElement('draft_button');
    displayElement('submit-button');

    hideElement('general_application_selectors');
    hideElement('confirm_button');

    displayElement('general-information-form');
    displayElement('google_recaptcha_container');
    showRestOfForm();
};

const displayElement = (fieldId) => document.getElementById(fieldId)?.classList.remove('hidden');

const hideElement = (fieldId) => document.getElementById(fieldId)?.classList.add('hidden');

const showRestOfForm = () => {
    displayElement('national_radio_form');
}

const handleError = (fileInput, errorMessage) => {
    fileInput.value = "";

    showErrorMessage(errorMessage, fileInput);
    disableSubmitButton();
}

const handleSuccess = (fileInput) => {
    enableSubmitButton();

    if (fileInput.nextSibling.tagName === 'SPAN') {
        fileInput.nextSibling.remove();
    }
}

const showErrorMessage = (text, fileInput) => {
    if (fileInput.nextSibling.tagName === 'SPAN') {
        fileInput.nextSibling.remove();
    }

    const errorSpan = document.createElement("span");

    if (errorSpan) {
        errorSpan.classList.add('error-span');
        errorSpan.textContent = text;
        fileInput.parentNode.insertBefore(errorSpan, fileInput.nextSibling);
    }
}

const disableSubmitButton = () => document.getElementById('submit-button').disabled = true;

const enableSubmitButton = () => document.getElementById('submit-button').disabled = false;

const handleFormSubmit = () => {
    const newApplicationForm = document.getElementById('new-application-form');
    const submitButton = document.getElementById('submit-button');

    newApplicationForm.addEventListener('submit', (event) => {
        removeErrors();

        disabledAllButtons();
        displayElement('progress-pr');

        event.preventDefault();

        const formData = new FormData(newApplicationForm, submitButton);
        formData.append('action', 'process_contact_form');

        const elements = newApplicationForm.elements;

        for (const element of elements) {
            const name = element.name;
            const value = element.value;

            if (name) {
                formData[name] = value;
            }
        }

        const request = new XMLHttpRequest();
        request.open('POST', myCustomScriptData.ajaxurl, true);

        request.onload = () => {
            if (request.status === 200) {
                const response = JSON.parse(request.responseText);

                if (response.success) {
                    jQuery(".progress-bar").text(100 + '%')
                    jQuery(".progress-bar").width(100 + '%')

                    setTimeout(() => {
                        window.location.href = '/wp-admin/edit.php?post_type=applications_cpt';
                    }, 2000);
                } else {
                    addErrorMessage(response);
                    //reloadCaptcha();

                    hideElement('progress-pr');
                    jQuery(".progress-bar").text(0 + '%')
                    jQuery(".progress-bar").width(0 + '%')
                    enableAllButtons();
                }
            } else if (request.status === 504) {
                jQuery(".progress-bar").text(100 + '%')
                jQuery(".progress-bar").width(100 + '%')

                setTimeout(() => {
                    window.location.href = '/wp-admin/edit.php?post_type=applications_cpt';
                }, 2000);
            }
        };
        request.upload.onprogress = (e) => {
            if (e.lengthComputable) {
                var percentComplete = ((e.loaded / e.total) * 100)
                if (parseInt(percentComplete) != 100) {
                    jQuery(".progress-bar").text(parseInt(percentComplete) + '%')
                    jQuery(".progress-bar").width(parseInt(percentComplete) + '%')
                }
            }
        }

        request.onerror = function () {
            console.error('An error occurred while submitting the form.');
        };

        request.send(formData);
    });
}

const addErrorMessage = (response) => {
    const labelName = isMultiple(response.input) ? response.input + '[]' : response.input;

    const labelWithError = (labelName === 'google_recaptcha_container')
        ? document.getElementById('google_recaptcha_container')
        : document.querySelector(`label[for="${labelName}"]`);

    if (labelWithError) {
        if (labelWithError.nextSibling.tagName === 'SPAN') {
            labelWithError.nextSibling.remove();
        }

        const errorSpan = document.createElement("span");

        if (errorSpan) {
            errorSpan.classList.add('error-span');
            errorSpan.textContent = response.error;
            labelWithError.parentNode.insertBefore(errorSpan, labelWithError.nextSibling);
        }
    }
}

const isMultiple = (label) => {
    return multiple_labels.includes(label);
}

const handleSaveDraft = () => {
    const newApplicationForm = document.getElementById('new-application-form');
    const draftButton = document.getElementById('draft_button');

    draftButton?.addEventListener('click', () => {
        removeErrors();

        disabledAllButtons();
        displayElement('progress-pr');

        const formData = new FormData(newApplicationForm);
        formData.append('action', 'save_application_draft');

        const elements = newApplicationForm.elements;

        for (const element of elements) {
            const name = element.name;
            const value = element.value;

            if (name) {
                formData[name] = value;
            }
        }

        const request = new XMLHttpRequest();
        request.open('POST', myCustomScriptData.ajaxurl, true);

        request.onload = () => {
            if (request.status === 200) {
                const response = JSON.parse(request.responseText);

                if (response.success) {
                    jQuery(".progress-bar").text(100 + '%')
                    jQuery(".progress-bar").width(100 + '%')

                    setTimeout(() => {
                        window.location.href = '/wp-admin/edit.php?post_type=applications_cpt';
                    }, 2000);
                } else {
                    addErrorMessage(response);
                    //reloadCaptcha();

                    hideElement('progress-pr');
                    jQuery(".progress-bar").text(0 + '%')
                    jQuery(".progress-bar").width(0 + '%')
                    enableAllButtons();
                }
            } else if (request.status === 504) {
                jQuery(".progress-bar").text(100 + '%')
                jQuery(".progress-bar").width(100 + '%')

                setTimeout(() => {
                    window.location.href = '/wp-admin/edit.php?post_type=applications_cpt';
                }, 2000);
            }
        };

        request.upload.onprogress = (e) => {
            if (e.lengthComputable) {
                var percentComplete = ((e.loaded / e.total) * 100)
                if (parseInt(percentComplete) != 100) {
                    jQuery(".progress-bar").text(parseInt(percentComplete) + '%')
                    jQuery(".progress-bar").width(parseInt(percentComplete) + '%')
                }
            }
        }

        request.onerror = function () {
            console.error('An error occurred while saving the application.');
        };

        request.send(formData);
    });
}

const removeErrors = () => {
    const errors = document.getElementsByClassName('error-span');

    for (const error of errors) {
        error.remove();
    }
}

const reloadCaptcha = () => {
    grecaptcha?.reset();
}

const disabledAllButtons = () => {
    const draftButton = document.getElementById('draft_button');
    const submitButton = document.getElementById('submit-button');

    if (draftButton && submitButton) {
        draftButton.disabled = true;
        submitButton.disabled = true;
    }
}

const enableAllButtons = () => {
    const draftButton = document.getElementById('draft_button');
    const submitButton = document.getElementById('submit-button');

    if (draftButton && submitButton) {
        draftButton.disabled = false;
        submitButton.disabled = false;
    }
}